import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Header, SidebarCollapsed } from '@/layout-components'
import { Outlet } from 'react-router'
import { Box } from '@mui/material'
import { wrapperSx, mainSx, contentSx } from '../chromeSx'
import { innerContentMainSx } from '../chromeComponentSx'

const CollapsedSidebar = () => {

  return (
    <>
      <Box data-hf="chrome-wrapper" sx={{ ...wrapperSx, height: '100vh' }}>
        <SidebarCollapsed />
        <Box sx={mainSx}>
          <Header />
          <Box
            sx={contentSx({
              sidebarFixed: true,
              headerFixed: true,
              collapsed: true,
           })}
          >
            <Box sx={innerContentMainSx}>
              <Outlet />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

CollapsedSidebar.propTypes = {
  children: PropTypes.node,
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(CollapsedSidebar)
